// TODO: Why is this pragma used? Applying types here shouldn't be a problem?
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

export const API_BASE = process.env.REACT_APP_API_BASE || '';
export const OCP_APIM_SUBSCRIPTION_KEY = process.env.REACT_APP_OCP_APIM_SUBSCRIPTION_KEY || '';
export const CONTENTFUL_ACCESS_TOKEN = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN || '';
export const CONTENTFUL_SPACE = process.env.REACT_APP_CONTENTFUL_SPACE || '';
export const CONTENTFUL_ENVIRONMENT = process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || '';
export const CONTENTFUL_ENTRY_ID_PRODUCT_CATALOG =
    process.env.REACT_APP_CONTENTFUL_ENTRY_ID_PRODUCT_CATALOG || '';
export const CONTENTFUL_ENTRY_ID_PRODUCT_CATALOG_SHOP_ONLINE =
    process.env.CONTENTFUL_ENTRY_ID_PRODUCT_CATALOG_SHOP_ONLINE || '';
export const ENABLE_DASHBOARD = 'true';
export const RAISE_RIGHT_APP_TYPE: 'mobile' | 'web' = (
    process.env.REACT_APP_RAISE_RIGHT_APP_TYPE || 'mobile'
).toLowerCase();
// If the app is Web we will use Duende's BFF Security Framework (SSO) instead of JWT Tokens for API auth.
// For the Mobile app everything keeps the same.
export const DO_NOT_ADD_BEARER_TOKENS = RAISE_RIGHT_APP_TYPE === 'web';
export const REACT_APP_LAUNCH_SCRIPWARE_URL = process.env.REACT_APP_LAUNCH_SCRIPWARE_URL;
export const PRODUCT_IMAGES_URL = process.env.REACT_APP_PRODUCT_IMAGES_URL || '';

export const FLIPGIVE_ORDERHISTORY_URL =
    process.env.REACT_APP_RUNTIME_ENVIRONMENT === 'prod'
        ? 'https://cloud.flipgive.com/trips?token=<token>&webview=true'
        : 'https://cloud.almostflip.com/trips?token=<token>&webview=true';
export const FLIPGIVE_WALLET_URL =
    process.env.REACT_APP_RUNTIME_ENVIRONMENT === 'prod'
        ? 'https://cloud.flipgive.com/wallet?token=<token>&webview=true&embedded=true'
        : 'https://cloud.almostflip.com/wallet?token=<token>&webview=true&embedded=true';
const isFlipGiveHostname =
    typeof window !== 'undefined' && window.location.hostname.includes('flipgive');
const isLocalFlipGiveDev =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') &&
    (window.location.port === '5004' || window.location.port === '5005');
export const IS_FLIPGIVE = isFlipGiveHostname || isLocalFlipGiveDev;

/** Public web origin for enrollment / invite fallbacks (e.g. af_web_dp). */
const RAISE_RIGHT_WEB_ENROLLMENT_ORIGIN = 'https://www.raiseright.com';
const FLIPGIVE_WEB_ENROLLMENT_ORIGIN = 'https://www.flipgive.com';
export const WEB_ENROLLMENT_ORIGIN = IS_FLIPGIVE
    ? FLIPGIVE_WEB_ENROLLMENT_ORIGIN
    : RAISE_RIGHT_WEB_ENROLLMENT_ORIGIN;

/** Native app URL scheme for AppsFlyer af_dp (must match shipped app link config). */
export const APP_DEEPLINK_SCHEME = IS_FLIPGIVE ? 'flipgiveapp' : 'swsapp';

/** Native-only runtime URL scheme. Web keeps this empty so shared imports type-check. */
export const APP_URL_SCHEME = '';

export const CONSTRUCTOR_KEY = IS_FLIPGIVE
    ? process.env.REACT_APP_FLIPGIVE_CONSTRUCTOR_KEY || ''
    : process.env.REACT_APP_CONSTRUCTOR_KEY || '';

export const GOOGLE_TAG_MANAGER_ID = IS_FLIPGIVE
    ? process.env.REACT_APP_FLIPGIVE_GOOGLE_TAG_MANAGER_ID || ''
    : process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID || '';

export const getLocale = () => {
    return IS_FLIPGIVE ? 'en-CA' : 'en-US';
};
export const Branding = IS_FLIPGIVE ? 'FlipGive' : 'RaiseRight';
export const BrandingLower = Branding.toLowerCase();

// OIDC Configuration for Duende IdentityServer
export const OIDC_ISSUER = process.env.OIDC_ISSUER || '';
export const OIDC_CLIENT_ID = process.env.OIDC_CLIENT_ID || '';
export const OIDC_REDIRECT_URI = process.env.OIDC_REDIRECT_URI || '';
export const OIDC_POST_LOGOUT_REDIRECT_URI = process.env.OIDC_POST_LOGOUT_REDIRECT_URI || '';
export const APP_AUTH_REDIRECT_SCHEME = process.env.APP_AUTH_REDIRECT_SCHEME || '';

export const BB_URL = IS_FLIPGIVE
    ? 'https://www.bbb.org/ca/on/toronto/profile/professional-fundraiser/flipgive-corporation-0107-1419480/#sealclick'
    : 'https://www.bbb.org/us/mi/grand-rapids/profile/fundraising-counselors-and-organizations/raiseright-llc-0372-13002078/#sealclick';

export const BB_IMAGE_URL = IS_FLIPGIVE
    ? 'https://seal-mwco.bbb.org/seals/black-seal-160-82-bbb-1419480.png'
    : 'https://seal-westernmichigan.bbb.org/seals/black-seal-160-82-bbb-13002078.png';
